import { defineStore } from "pinia"
import { ref } from 'vue'
import { intersect } from "@/utils/collections"

export const useRetrieveTasksStore = defineStore('retrieveTasks', () => {
  type Tasks = {
    [cloud_construction_id: string]: Array<string>
  }
  const tasks = ref<Tasks>({})

  const getRunningItemTypes = ({ cloud_construction_id, item_types }: {
    cloud_construction_id: string,
    item_types: Array<string>
  }) => {
    const currentItemTypes = tasks.value[cloud_construction_id]
    if(!currentItemTypes) return null

    const runningItemTypes = intersect(currentItemTypes, item_types)
    if(runningItemTypes.length < 1){
      return null
    }
    return runningItemTypes;
  }

  const clearTasks = () => {
    tasks.value = {}
  }

  const startTasks = ({ cloud_construction_id, item_types }: {
    cloud_construction_id: string,
    item_types: Array<string>
  }) => {
    item_types.forEach(item_type => {
      const curTasks = tasks.value
      const curItemTypes = 
        curTasks[cloud_construction_id] ? curTasks[cloud_construction_id] : []
      const added = [ item_type, ...curItemTypes ]
      const uniq = [...new Set(added)]
      tasks.value[cloud_construction_id] = uniq
      tasks.value = Object.assign({}, tasks.value, tasks.value)
    })
  }
  
  const finishTask = ({ cloud_construction_id, item_type }: {
    cloud_construction_id: string,
    item_type: string
  }) => {
    const curTasks = tasks.value
    const curItemTypes = 
      curTasks[cloud_construction_id] ? curTasks[cloud_construction_id] : []
    const deleted = curItemTypes.filter(itm => itm !== item_type)
    const uniq = [...new Set(deleted)]
    tasks.value[cloud_construction_id] = uniq
    tasks.value = Object.assign({}, tasks.value, tasks.value)
  }
  
  return {
    tasks,
    getRunningItemTypes,
    clearTasks,
    startTasks,
    finishTask,
  }
})
